import { tracked } from "@glimmer/tracking";
import { Channel } from "#models/channel.ts";
import { trackedArray } from "@ember/reactive/collections";
import { Sound } from "#models/sound.ts";

export interface SongInit {
  name?: string;
  tempo?: number;
  channels?: Channel[];
}

export class Song {
  @tracked name: string;
  @tracked tempo: number;
  @tracked channels: Channel[];

  constructor(init: SongInit = {}) {
    this.name = init.name || "Untitled";
    this.tempo = init.tempo ?? 100;
    this.channels = trackedArray(init.channels ?? []);
  }

  addChannel(sound?: Sound): Channel {
    const channel = new Channel({ sound: sound ?? Sound.DEFAULT });
    this.channels.push(channel);
    return channel;
  }

  removeChannel(channel: Channel): boolean {
    const idx = this.channels.indexOf(channel);
    if (idx !== -1) {
      this.channels.splice(idx, 1);
      return true;
    } else {
      return false;
    }
  }

  serialize(): {
    name: string;
    tempo: number;
    channels: ReturnType<InstanceType<typeof Channel>["serialize"]>[];
  } {
    return {
      name: this.name,
      tempo: this.tempo,
      channels: this.channels.map((channel) => channel.serialize()),
    };
  }

  static deserialize(data: {
    name?: string;
    tempo?: number;
    channels?: Parameters<typeof Channel.deserialize>[0][];
  }): Song {
    const channels = (data.channels ?? []).map((cData) => Channel.deserialize(cData));
    return new Song({
      name: data.name ?? "Untitled",
      tempo: data.tempo ?? 100,
      channels,
    });
  }
}
